module.exports = __webpack_public_path__ + "static/media/appMockup-1.3180038a.svg";